import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { StoreVariableService } from '../store-variable.service';
import { RootService } from 'src/app/shared/services/root.service';
import { environment } from  '../../../environments/environment';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  constructor(private ApiService: ApiService, private storeservice: StoreVariableService, private toastrService: ToastrService, @Inject(PLATFORM_ID) private platformId: Object, private router: Router, private storageService: RootService) { }
  environment1 = environment.s3bucket.url;
  userEnteredValue: any = '';
  userLogIn: any;
  sub: Subscription = new Subscription();
  selectedLevel2ID: any;
  selectedLevel3ID: any;
  l2Data: any;
  level2Data: any[] = [];
  level3data: any[] = [];
  searchDataList: any = [];
  listingData: any = [];
  breadCrumb: {
    l1_actual_name: string,
    l2_actual_name: string,
    l3_actual_name: string,
    l4_actual_name: string,
    filterCount: number,
  };
  ngOnInit(): void {
    this.userLogIn = this.storageService.getUserData() ? true : false;
  }
  getSmartSearch(value: any) {
    this.userEnteredValue = ''
    let data = {
      "search": value,
      "offset": 0,
      "limit": 20
    }
    this.userEnteredValue = value
    this.sub.add(this.ApiService.getSearchValue(data).subscribe({
      next: (res: any) => {
        if (res.success) {
          // let data = res.data[0].actual_value;
          let data = res.result[0].actual_value

          this.onSearchClick(data, '', '',value)
        }
        else {
          // document.getElementById('searchConsoleDefult').click()
          this.toastrService.warning(res.data.msg)
          return;
        }
      },
      complete() {

      }
    }))
  }
  onSearchClick(level1: any, level2: any, level3: any,search:any) {
    if (isPlatformBrowser(this.platformId)) {
      this.clearLocalStorageData();
      if (level3 != '' && level3 != undefined && level3 != null)
        localStorage.setItem('pageLevel', '3');

      if (!localStorage.getItem('l1SearchData') || level1 != '') {
        this.selectedLevel2ID = null;
        this.selectedLevel3ID = null;
        localStorage.removeItem('l2SearchData')
        this.l2Data = [];
        this.level3data = [];
        this.level2Data = [];
        localStorage.setItem('l1SearchData', level1);
        localStorage.setItem('pageLevel', '1');
      }

      if (
        localStorage.getItem('pageLevel') == '2' &&
        !localStorage.getItem('l2SearchData')
      ) {
        localStorage.removeItem('l3SearchData');
        this.selectedLevel3ID = null;
        localStorage.setItem('l2SearchData', JSON.stringify(level2));
      }
      if (localStorage.getItem('l2SearchData')) {
        localStorage.removeItem('l3SearchData');
        this.selectedLevel3ID = null;
        this.l2Data = JSON.parse(localStorage.getItem('l2SearchData'));
      }

      if (
        this.level2Data?.length > 1 &&
        localStorage.getItem('pageLevel') == '3' &&
        !localStorage.getItem('l3SearchData')
      ) {
        localStorage.setItem('l3SearchData', level3);
      }
      let data = {
        level1: localStorage.getItem('l1SearchData')
          ? localStorage.getItem('l1SearchData')
          : level1,
        level2: this.l2Data ? this.l2Data.l2_actual_name : level2.l2_actual_name,
        level3: localStorage.getItem('l3SearchData')
          ? localStorage.getItem('l3SearchData')
          : level3,
        search: this.userEnteredValue ? this.userEnteredValue : ''
      };


      this.sub.add(
        this.ApiService.advanceSearch(data).subscribe({
          next: (res: any) => {
            if (res.success) {
              this.searchDataList = res.data;


              let tempBreadCrumb = {
                l1_actual_name: '',
                l2_actual_name: '',
                l3_actual_name: '',
                l4_actual_name: '',
                filterCount: 0
              }
              if (level1 != '') {
                tempBreadCrumb.l1_actual_name = res.data.l1_actual_name
                // this.breadCrumb = tempBreadCrumb;
                // document.getElementById('searchBtn').click();
              }
              if (localStorage.getItem('pageLevel') == '1') {
                let data = res.data.data

                this.listingData = data
                if (this.listingData?.length > 0) {
                  // this.router.navigate(['advancesearch1/vehicle-map']);
                  this.storeservice.listingData = this.listingData;
                  // this.router.navigate(['advancesearch1/vehicle-map']);
                }

                // this.router.navigate(['advancesearch1/vehicle-map', { listingData: JSON.stringify(this.listingData), breadCrumb: JSON.stringify(this.breadCrumb) }]);
                // this.router.navigate(['advancesearch1', 'vehicle-map']);
                // setTimeout(() => {
                //   this.listingData = data
                //   // if (this.listingData?.length <= 3) {
                //     // this.listingData = this.listingData.concat(this.listingData)
                //   // }
                // }, 500);


              }
              if (localStorage.getItem('pageLevel') == '3') {
                tempBreadCrumb.l1_actual_name = res.data.l1_actual_name
                tempBreadCrumb.l2_actual_name = res.data.l2_actual_name
                this.level3data = res.data.data ? res.data.data : [];


              }
              if (localStorage.getItem('pageLevel') == '2') {
                tempBreadCrumb.l1_actual_name = res.data.l1_actual_name
                tempBreadCrumb.l2_actual_name = res.data.l2_actual_name
                this.level2Data = this.searchDataList.data

              }


              this.breadCrumb = tempBreadCrumb;
              this.storeservice.breadCrumb = this.breadCrumb;
              this.storeservice.isclick.next(false)
              this.router.navigate(['advancesearch/',search, this.breadCrumb.l1_actual_name]);

            }
          },
          error: (error: any) => { },
          complete: () => {

          },
        })
      );
    }
  }
  clearLocalStorageData() {
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem('pageLevel') === '1') {
        localStorage.removeItem('l2SearchData');
        localStorage.removeItem('l3SearchData');
      }
      if (localStorage.getItem('pageLevel') === '2') {
        localStorage.removeItem('l3SearchData');
      }
    }
  }
  enterClickData(data) {
    if (isPlatformBrowser(this.platformId)) {
      let element = document.getElementById('searchBtn');
      element.click();
    }
  }
  goTohome() {
    if (this.userLogIn) {
      this.router.navigate(['/home'])

    } else {
      this.router.navigate(['/login'])
    }

  }
}
